export default __webpack_public_path__ + "static/media/santhosh.500ac2d8.jpg";